// PromoCodeHandler.js

(function() {
    // Helper function to get a query parameter by name, case-insensitive
    function getCaseInsensitiveParameter(name) {
        const params = new URLSearchParams(window.location.search);
        for (const [key, value] of params.entries()) {
            if (key.toLowerCase() === name.toLowerCase()) {
                return decodeURIComponent(value.replace(/\+/g, ' '));
            }
        }
        return null;
    }

    // Check for PROMO (case-insensitive) in the URL
    const promoCode = getCaseInsensitiveParameter('PROMO');
    if (promoCode) {
        sessionStorage.setItem('PROMO', promoCode);
    }

    // Function to append promocode to relevant links
    function appendPromoCodeToLinks() {
        const storedPromoCode = sessionStorage.getItem('PROMO');
        if (!storedPromoCode) return;

        const links = document.querySelectorAll('a[href*="secure.southbankcentre.co.uk"]');
        links.forEach(link => {
            try {
                const url = new URL(link.href);
                url.searchParams.set('promo', storedPromoCode);
                link.href = url.toString();
            } catch (e) {
                // Invalid URL, skip
            }
        });
    }

    // Run on page load
    appendPromoCodeToLinks();

    // Run on subsequent page loads
    window.addEventListener('load', appendPromoCodeToLinks);
})();
